module.exports = __webpack_public_path__ + "img/1440.ff623578.jpg";